import { collection, query, where, onSnapshot, doc, updateDoc } from 'firebase/firestore'
import firebase from '@/config/firebaseConfig' // Adjust path as needed

export const listenToCollection = (collectionName, callback, filters = {}) => {
  const collectionRef = collection(firebase.db, collectionName)
  const q = filters.read !== undefined 
    ? query(collectionRef, where('read', '==', filters.read))
    : collectionRef

  return onSnapshot(q, (snapshot) => {
    const docs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    callback(docs)
  })
}

export const markNotificationAsRead = async (notificationId) => {
  const notifRef = doc(firebase.db, 'notifications', notificationId)
  await updateDoc(notifRef, {
    read: true
  })
}
